class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const container = this.querySelector("[data-recommendations]");
    if (!container) {
      return;
    }

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((markup) => {
        const html = new DOMParser().parseFromString(markup, "text/html").querySelector("[data-recommendations]")?.innerHTML;
        if (!html) {
          return;
        }
        this.classList.remove("hidden");
        container.innerHTML = html;
        this.initSlider();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  initSlider() {
    if (this.slider) {
      return;
    }
    const mount = () => {
      if (this.slider) {
        return;
      }
      const element = this.querySelector(".swiper");
      if (!element) {
        return;
      }
      this.slider = new Swiper(element, {
        slidesPerView: "auto",
        spaceBetween: 8
      });
    };
    const loader = window.themeLibraryLoader;
    if (loader && typeof loader.whenSwiperReady === "function") {
      loader.whenSwiperReady(mount);
    } else if (window.Swiper) {
      mount();
    }
  }
}

customElements.define("cart-recommendations", CartRecommendations);
